import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

interface GetAlterRes {
  data: boolean;
}
export async function getAlterPop() {
  const url = config.zqhpLink + '/activity/competition-welfare/getAlter';
  return zqhdApi.fetch<GetAlterRes>(url);
}
